<mat-form-field>
  <mat-label>{{ title }}</mat-label>
  <mat-select
    [required]="required"
    [formControl]="queueControl"
    (selectionChange)="onSelectionChange($event.value)"
  >
    @if (allowNone) {
      <mat-option>None</mat-option>
    }
    @for (group of projectQueuesGroups; track group) {
      <mat-optgroup [label]="group.name">
        @for (queue of group.queues; track queue) {
          <mat-option [value]="queue.id">
            {{ queue.name }}
          </mat-option>
        }
      </mat-optgroup>
    }
  </mat-select>
  @if (hint) {
    <mat-hint class="hint">{{ hint }}</mat-hint>
  }
</mat-form-field>
